export const negotiationSupplierProgressType = 'negotiation_supplier_progress';
